export const PRODUCT_UNIVERSE_SATELLITE_COUNT = 14;

export function stepProductFocus(
  currentIndex: number | null,
  direction: -1 | 1,
  count = PRODUCT_UNIVERSE_SATELLITE_COUNT,
): number {
  if (count <= 0) return 0;
  if (currentIndex === null) return direction > 0 ? 0 : count - 1;
  return (currentIndex + direction + count) % count;
}
